var _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatarPupil = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "avatar_pupil_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 20,
  height: 20
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#avatar_pupil_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.999,
  cy: 11,
  r: 13.333,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.011 9.138-3.513-1.48C6.527 5.887 6.746 5 7.322 5c.62 0 .62 1.448 3.724 1.448C14.149 6.448 14.149 5 14.77 5c.575 0 .794.886.823 2.659L12.08 9.138h-2.069ZM15.684 10.524c.14.233.26.476.362.728.056.131.105.265.147.402.15.456.229.934.232 1.415 0 1.405-.718 2.445-1.854 3.103-.944.549-2.177.828-3.526.828-1.349 0-2.582-.28-3.525-.828-1.136-.658-1.854-1.698-1.854-3.103.003-.481.081-.959.232-1.415.042-.137.091-.27.147-.402.101-.252.222-.495.362-.728l3.604-1.386h2.069l3.604 1.386Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.046,
  cy: 14.517,
  rx: 2.069,
  ry: 2.483,
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.046 17H7.322a.415.415 0 0 1-.414-.414.417.417 0 0 1 .414-.414h.199c.943.549 2.176.828 3.525.828Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.183 16.586a.415.415 0 0 1-.414.414h-3.724c1.349 0 2.582-.28 3.525-.828h.2a.417.417 0 0 1 .413.414Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.012 9.138a2.067 2.067 0 1 1-4.135-.004 2.067 2.067 0 0 1 4.135.004ZM16.218 9.138a2.073 2.073 0 1 1-4.146.008 2.073 2.073 0 0 1 4.146-.008Z",
  fill: "#E7E8E8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.83 9.708c0 .45-.815 1.886-.815 1.886s-.816-1.436-.816-1.886a.815.815 0 0 1 1.632 0Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8.148,
  cy: 9.138,
  fill: "#405B73",
  r: 0.621
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.941,
  cy: 9.138,
  r: 0.621,
  fill: "#405B73"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10,
  stroke: "#EDF4F3"
})));
export default SvgAvatarPupil;